import React from 'react';

export default () => {
    return <div style={{background: '#3f3f3f', height: '100%'}}>    
        <h2>404 - Not found :(</h2>
        </div>
}